export const tableConfig = [
  {
    id: 1,
    label: 'Name',
    isSortable: true,
    parameter: 'name'
  },
  {
    id: 2,
    label: 'Description',
    isSortable: false,
    parameter: null
  },
  {
    id: 3,
    label: 'Status',
    isSortable: true,
    parameter: 'active'
  },
  {
    id: 4,
    label: 'Prefix',
    isSortable: false
  },
  {
    id: 5,
    label: '',
    isSortable: false
  }
];
